// A table that sorts by a column: a click on a header marked data-sort orders the rows by that column's cells (each
// cell's data-v, a number; a blank sorts last), largest first, again for smallest first (#754: /stats, how they fight).
export function initSort(root: ParentNode = document) {
  root.querySelectorAll<HTMLTableElement>("table[data-sortable]").forEach((table) => {
    if (table.dataset.sortWired) return;
    table.dataset.sortWired = "1";
    const heads = Array.from(table.querySelectorAll<HTMLTableCellElement>("thead th"));
    heads.forEach((th, col) => {
      if (!th.hasAttribute("data-sort")) return;
      th.tabIndex = 0;
      th.classList.add("sortable");
      const sort = () => {
        const down = th.getAttribute("aria-sort") !== "descending";
        heads.forEach((h) => h.removeAttribute("aria-sort"));
        th.setAttribute("aria-sort", down ? "descending" : "ascending");
        const body = table.tBodies[0];
        if (!body) return;
        const value = (row: HTMLTableRowElement) => {
          const v = row.cells[col]?.dataset.v;
          return v === undefined || v === "" ? null : Number(v);
        };
        const rows = Array.from(body.rows).filter((r) => r.cells.length === heads.length);
        rows.sort((a, b) => {
          const va = value(a),
            vb = value(b);
          if (va === null) return vb === null ? 0 : 1;
          if (vb === null) return -1;
          return down ? vb - va : va - vb;
        });
        rows.forEach((r) => body.appendChild(r));
      };
      th.addEventListener("click", sort);
      th.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          sort();
        }
      });
    });
  });
}
